export const roundDecimals = (value: number, decimals = 0): number => {
  return Number(value.toFixed(decimals));
};
